// extracted by mini-css-extract-plugin
export var pressed = "ToggleButton-module--pressed--UK-PQ";
export var root = "ToggleButton-module--root--IxYKD";